import React, { useState, useEffect } from 'react';
import { supabase } from '../../lib/supabase';
import { useTenantConfig } from '../../hooks/useTenant';
import { TenantPreferences } from './TenantAdminView';
import { F, C } from '../../config/styles';

export function WorkspaceSettingsView() {
  const tenantConfig = useTenantConfig();
  const [tenant,  setTenant]  = useState(null);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);

  useEffect(() => {
    // get_tenant_for_login (SECURITY DEFINER) returns the full config for your own tenant
    // once authenticated — same RPC useTenant.js uses. A direct .from('tenants') select is
    // subject to RLS same as any other client query; this bypasses that class of issue.
    supabase.rpc('get_tenant_for_login', { p_subdomain: tenantConfig.subdomain })
      .then(({ data, error: err }) => {
        if (err) setError(err.message);
        else if (!data) setError('Workspace not found');
        else setTenant(data);
        setLoading(false);
      });
  }, [tenantConfig.subdomain]);

  if (loading) return (
    <div style={{ padding: 40, fontSize: 14, color: C.muted, fontFamily: F.body }}>Loading…</div>
  );

  if (error) return (
    <div style={{ padding: 40, fontSize: 14, color: '#dc2626', fontFamily: F.body }}>Couldn't load Settings: {error}</div>
  );

  if (!tenant) return null;

  return (
    <TenantPreferences
      tenant={tenant}
      onBack={null}
      onUpdate={updated => setTenant(updated)}
      allowedSections={tenantConfig.studioOnly ? ['branding', 'croppresets', 'integrations'] : undefined}
    />
  );
}
